// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IFilterVacanciesRequest, TFilterVacanciesModel, IMappers, TFilterVacanciesResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IVacancyWithCompanyPagingListSchemaSchema } from '../../entities/schemas/VacancyWithCompanyPagingListSchemaSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createFilterVacanciesModel(parameters: IFilterVacanciesRequest): TFilterVacanciesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'vacancies',
    pathApi: '/v1/filter-vacancies/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IFilterVacanciesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IFilterVacanciesRequest;
}

export async function fetchFilterVacancies<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IFilterVacanciesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TFilterVacanciesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createFilterVacanciesModel(parameters),
    config,
  )) as FetchResponse<TFilterVacanciesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IVacancyWithCompanyPagingListSchemaSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TFilterVacanciesResponse>;
}
